import { useEffect, useRef } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { notification } from 'antd';
import sendEvent from '@/modules/monitoring/sendEvent';

export default function useStripePromiseHook() {
  const stripePromiseRef = useRef(null);

  useEffect(() => {
    const handleUnhandledRejection = (event) => {
      if (event.reason && event.reason.message === 'Failed to load Stripe.js') {
        notification.error({
          message: 'We weren’t able to load the payment form.',
          description: (
            <p>
              Please contact{' '}
              <a href="mailto:support@rockalingua.com">
                support@rockalingua.com
              </a>
            </p>
          ),
          duration: 0,
        });
        sendEvent({
          type: 'STRIPE_ERROR',
          data: {
            pathname: window.location.pathname,
            search: window.location.search,
          },
          result: 'error',
        });
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    stripePromiseRef.current = loadStripe(
      process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY
    );

    return () => {
      window.removeEventListener(
        'unhandledrejection',
        handleUnhandledRejection
      );
    };
  }, []);

  return stripePromiseRef;
}
